module.exports = "/images/tkSocial.png?d147e62ade9614b2226edb9941f2fae3";